<template>
  <VList data-testid="portal-event-list" bg-color="backgroundDiv">
    <VListItem v-if="!events.length" class="font-weight-bold background-main">
      {{ $t('p.calendar.noEntries') }}
    </VListItem>
    <VListItem v-for="(event, index) in events" v-else :key="index" class="py-2">
      <VRow :data-testid="`portal-event-item-${index}`" no-gutters class="background-main event-item pa-4">
        <VCol class="text-header font24 shrink pr-4">
          {{ getDay(event.eventStart) }}
        </VCol>
        <VCol>
          <p class="text-uppercase font-weight-medium font12 mb-0 pointer">
            {{ event.title }}
          </p>
          <p class="font12 text-greyedOut pt-1 mb-0">
            {{ event.summary }}
          </p>
        </VCol>
      </VRow>
    </VListItem>
  </VList>
</template>
<script setup lang="ts">
import { useEventStore } from '~/stores/events'

const eventStore = useEventStore()

const events = computed(() => eventStore.events)

const getDay = (date: string) => (new Date(date).getUTCDate())

</script>

<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}
.event-item {
  border-radius: 6px;
  line-height: 21px;
  color: rgb(var(--v-theme-on-surface));
}
</style>
